import { ApiProperty } from '../codegen';
import { IsOptional, IsString } from '../validators';

export class LangDto {
  @ApiProperty()
  @IsOptional()
  @IsString()
  current?: string;

  @ApiProperty()
  @IsOptional()
  @IsString()
  locale?: string;
}
